import colors from './colors';
import fonts from './fonts';
import metrics from './metrics';
import appStyles from './appStyles';

export { colors, metrics, appStyles, fonts };



// WEBPACK FOOTER //
// ./src/theme/index.js